<template>
  <h1>Not Found</h1>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/NotFound.vue